import type { Thread } from '@wovin/core/thread'
import { Logger } from 'besonders-logger'
import { useAgent } from './AgentState'
import { onlyFromAgent } from '../block-utils-nowin'

const { WARN, LOG, DEBUG, VERBOSE, ERROR } = Logger.setup(Logger.INFO) // eslint-disable-line unused-imports/no-unused-vars

export function onlyFromCurrentAgent(
	thread: Thread,
) {
	DEBUG(`onlyFromCurrentAgent<${thread.nameAndSizeUntracked}>`)
	const { ag } = useAgent()

	return onlyFromAgent(thread, ag)
}
